import React, { useState } from 'react'
import './index.scss';
import { useNavigate } from 'react-router-dom';
import {
    Form,
    Input,
    Tabs,
    Space,
    Button,
    message
} from 'antd';
import { mobile } from "../../utils/util";
import { user } from '../../service';

export default function RegisterView() {
    const navigate = useNavigate()
        , [form] = Form.useForm()
        , [countdown, setCountdown] = useState(0)
        , [loading, setLoading] = useState(false)

    const handleSendCodeClick = async () => {
        const { phone } = await form.getFieldsValue()
        if (!mobile(phone)) return;

        // 请求成功后倒计时为60秒，并开始倒计时
        if (countdown === 0) {

            // 发送验证码
            await user.getCode(phone, '0')

            // 倒计时
            setCountdown(60);

            const timer = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown > 0) {
                        return prevCountdown - 1;
                    } else {
                        clearInterval(timer);
                        return 0;
                    }
                });
            }, 1000);
        } else {
            message.warning('请等待倒计时结束后再重新发送验证码。');
        }
    };


    const onRegister = async () => {
        try {
            const { phone, pwd, code } = await form.validateFields()
            setLoading(true)
            await user.register({ phone, pwd, code })
            message.success('注册成功');
            setLoading(false)
            navigate(`/login`)
        } catch (error) {
            console.log(error);
            setLoading(false)
        }

    }

    // 手机号格式校验提示
    const CustomPhoneRule = (rule, value) => {
        if (mobile(value)) {
            return Promise.resolve();
        } else {
            return Promise.reject('请输入正确的手机号！');
        }
    };

    return (
        <div className='register-container'>
            <div className='bg'>

                <div className='title color-primary' onClick={() => navigate('/')}>有农社会化服务管理平台注册</div>

                <div className='form-content'>
                    <Form
                        form={form}
                        component={false}
                        name="register.form"
                        labelCol={{ span: 5 }}
                    >
                        <Form.Item
                            name='phone'
                            label="手机号"
                            rules={[
                                { validator: CustomPhoneRule },
                            ]}
                        >
                            <Input size='large' placeholder={`请输入手机号`} />
                        </Form.Item>

                        <Form.Item
                            name="pwd"
                            label="密码"
                            rules={[{ required: true, message: '请输入密码' }]}
                        >
                            <Input.Password size='large' placeholder={`请输入密码`} />
                        </Form.Item>

                        <Form.Item
                            name="code"
                            label="验证码"
                            rules={[{ required: true, message: '请输入验证码' }]}
                            wrapperCol={{ span: 19 }}
                        >

                            <Space.Compact
                                size="large"
                            >
                                <Input placeholder="请输入验证码" />
                                <Button
                                    type="primary"
                                    onClick={handleSendCodeClick}
                                    disabled={countdown > 0}
                                >
                                    {countdown > 0 ? `重新获取(${countdown})` : '发送验证码'}
                                </Button>
                            </Space.Compact>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type='primary'
                                block
                                size='large'
                                style={{ marginTop: '20px' }}
                                onClick={onRegister}
                                loading={loading}
                            >注 册</Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>

        </div>
    )
}
